import type { PixelEvent } from '@/events';

import type { PipelineStage } from '../types';

export class ValidateStage implements PipelineStage {
  readonly name = 'validate';

  process(event: PixelEvent): PixelEvent | null {
    if (!event.type || typeof event.type !== 'string') {
      return null;
    }

    if (typeof event.timestamp !== 'number' || Number.isNaN(event.timestamp)) {
      return null;
    }

    return event;
  }
}
